import React from 'react';

const SearchNoResultDark = (): JSX.Element => (
	<svg
		width="200"
		height="200"
		viewBox="0 0 275 275"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M191.87 88.6702C189.59 84.3102 186.8 79.9902 183.57 75.8102C180.3 71.5802 176.77 67.7402 173.07 64.4102C151.47 44.9002 123.96 41.9102 97.58 56.2202C93.31 58.5402 89.09 61.3002 85.04 64.4402C80.83 67.6902 76.96 71.2302 73.51 74.9502C53.12 96.9602 49.08 124.3 62.42 149.98C64.72 154.4 67.54 158.79 70.81 163.02C74.04 167.2 77.53 170.98 81.18 174.28C93.68 185.57 108.23 191.29 123.43 191.29C134.33 191.29 145.56 188.35 156.61 182.41C161.07 180.01 165.47 177.15 169.68 173.89C173.74 170.75 177.47 167.36 180.79 163.82C201.31 141.86 205.35 114.47 191.87 88.6802V88.6702ZM161.31 163.04C157.7 165.83 153.94 168.29 150.14 170.33C128.76 181.81 107.54 179.6 90.38 164.1C87.33 161.34 84.4 158.16 81.66 154.62C78.89 151.03 76.5 147.34 74.58 143.65C63.91 123.12 67.1 102.02 83.56 84.2502C86.49 81.0802 89.81 78.0602 93.42 75.2702C96.89 72.5802 100.49 70.2302 104.12 68.2602C113.08 63.4002 122.03 60.9802 130.69 60.9802C142.58 60.9802 153.9 65.5402 163.89 74.5702C166.98 77.3602 169.96 80.6002 172.73 84.1902C175.46 87.7302 177.82 91.3702 179.72 95.0102C190.49 115.63 187.32 136.74 170.77 154.45C167.96 157.46 164.77 160.35 161.29 163.04H161.31Z"
			fill="#4B4D51"
		/>
		<path
			d="M179.96 171C176.42 166.07 172.62 166.1 168.91 168.97C165.43 171.66 164.5 175.3 168.21 180.09L172.45 185.57L184.2 176.48L179.96 171Z"
			fill="#4B4D51"
		/>
		<path
			d="M187.155 174.199L169.513 187.839L202.665 230.717L220.307 217.077L187.155 174.199Z"
			fill="#4B4D51"
		/>
		<path
			d="M184.32 176.391L172.35 185.646L183.593 200.186L195.562 190.932L184.32 176.391Z"
			fill="#7E8188"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M157.715 95.8255L103.735 149.805L96.6643 142.734L150.644 88.7544L157.715 95.8255Z"
			fill="#4B4D51"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M150.644 149.805L96.6643 95.8255L103.735 88.7544L157.715 142.734L150.644 149.805Z"
			fill="#4B4D51"
		/>
	</svg>
);

export default SearchNoResultDark;
